import "./style.css"
import React, { useEffect, useMemo, useState } from "react";
import { Layout } from "antd";
import { Navigate } from "react-router-dom";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import { getUser } from "Util/index";
import dayjs from "dayjs";
import RenderModules from "./renderModules";
// T2/100A67: marcadores retirados. Antes: import MarkerList from "components/marker/list";
import { pathPortal } from "Path";
import { submenuInformes, submenuConfigCotizaciones } from "./modules";
import { TABS } from "./tabs";
import { visibleTabs } from "./menu";
import { usePermiso } from "components/Permisos/PermisosContext";
// T4/100A01: menú lateral colapsable, solo con REACT_APP_UI_SIDEBAR_COLAPSABLE=true.
import AppSidebar from "components/layout/AppSidebar";
import { SIDEBAR_COLLAPSIBLE } from "config/featureFlags";
// T4/100A04: en celular el menú lateral se puede ocultar/mostrar.
import useIsMobile from "Hooks/useIsMobile";

// T4/100A02: menú fijo; ya no se recuerda oculto/visible. Antes:
// const SIDEBAR_KEY = "HOME-SIDEBAR-COLLAPSED";
// const readCollapsed = () => {
//   try {
//     return localStorage.getItem(SIDEBAR_KEY) === "1";
//   } catch (error) {
//     console.error("[Menú lateral] No se pudo leer el estado:", error);
//     return false;
//   }
// };

function Modules(props) {
  const { allow } = usePermiso();
  const [active, setActive] = useState("comercial");
  const [subActive, setSubActive] = useState(null);
  // T4/100A04: en celular el menú entra oculto y se abre con el botón; en escritorio sigue fijo.
  const isMobile = useIsMobile();
  const [mobileCollapsed, setMobileCollapsed] = useState(true);
  // T4/100A02: menú fijo (sin ocultar). Antes:
  // // T4/100A01: menú oculto/visible, recordado por navegador.
  // const [collapsed, setCollapsed] = useState(readCollapsed);
  // const toggleSidebar = () =>
  // setCollapsed((current) => {
  // try {
  // localStorage.setItem(SIDEBAR_KEY, current ? "0" : "1");
  // } catch (error) {
  // console.error("[Menú lateral] No se pudo guardar el estado:", error);
  // }
  // return !current;
  // });

  const User = getUser() || { customer: null };
  const hour = dayjs().format("HH");
  let msn = hour < 12 ? "Buenos días" : hour < 18 ? "Buenas tardes" : "Buenas noches";
  const firstName = User?.name?.split(" ")[0] || "";

  const SUBMENUS = {
    informes: { title: "Informes", modules: submenuInformes },
    configCotizaciones: { title: "Config. cotizaciones", modules: submenuConfigCotizaciones },
  };

  const change = (key) => {
    localStorage.setItem("HOME-TAB", key);
    setActive(key);
    setSubActive(null);
  };

  useEffect(() => {
    const homeTab = localStorage.getItem("HOME-TAB");
    if (homeTab) setActive(homeTab);
  }, []);

  // A tab shows iff at least one of its gated tiles shows (see ./menu.js).
  const modulesAllow = useMemo(() => {
    const tabs = visibleTabs(TABS, allow);
    // T2/100A82: diagnóstico de pestañas visibles en el inicio (solo con npm start).
    if (process.env.NODE_ENV === "development") {
      console.log(`[MENÚ INICIO] pestañas visibles ${tabs.length}/${TABS.length}:`, tabs.map((t) => t.key).join(", "));
    }
    return {
      main: tabs.filter((t) => t.group === "main"),
      global: tabs.filter((t) => t.group === "global"),
      bottom: tabs.filter((t) => t.group === "bottom"),
    };
  }, [allow]);

  const allModules = [
    ...(modulesAllow.main || []),
    ...(modulesAllow.global || []),
    ...(modulesAllow.bottom || []),
  ];

  const activeModule = allModules.find(m => m.key === active);
  const activeModules = activeModule?.modules || [];

  const SidebarItem = ({ item }) => (
    <div
      className={`jag-sidebar-item ${active === item.key ? 'active' : ''} ${item.isGlobal ? 'global' : ''}`}
      onClick={() => change(item.key)}
    >
      <span className="jag-sidebar-icon">{item.icon}</span>
      <span className="jag-sidebar-label">{item.name}</span>
    </div>
  );

  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Navbar showSwitchMarker={false} />

        {User?.customer ? (
          // Evolved seam (portal-clientes-rediseno, Phase 8 / Scope F): this
          // branch previously rendered <CustomerDashboard> inline. The
          // primary route boundary now lives at the top of the route tree
          // (components/portal/RouteBoundary, wired in Entry.js) and
          // redirects a customer-portal user to /portal before Modules ever
          // mounts. This redirect is kept here too as a defense-in-depth
          // fallback — same tested react-router-dom `<Navigate>` primitive,
          // no new branching logic introduced.
          <Navigate to={pathPortal.home} replace />
        ) : (
          <div className="jag-home">
            {/* SIDEBAR */}
            {/* T4/100A01: con la variable, el menú es components/layout/AppSidebar
                (colapsable a barra de iconos). Sin ella, el marcado original de abajo. */}
            {SIDEBAR_COLLAPSIBLE ? (
              // T4/100A02: menú fijo, siempre abierto y sin botón de ocultar (pedido del usuario).
              // Antes: <AppSidebar ... collapsible collapsed={collapsed} onToggle={toggleSidebar} />
              // T4/100A04: antes <AppSidebar tabs={modulesAllow} active={active} onSelect={change} />
              <AppSidebar
                tabs={modulesAllow}
                active={active}
                onSelect={(key) => {
                  change(key);
                  if (isMobile) setMobileCollapsed(true);
                }}
                collapsible={isMobile}
                collapsed={mobileCollapsed}
                onToggle={() => setMobileCollapsed((c) => !c)}
              />
            ) : (
            <div className="jag-sidebar">
              <div className="jag-sidebar-sections">

                <div className="jag-sidebar-group">
                  <div className="jag-sidebar-group-label">Departamentos</div>
                  {(modulesAllow.main || []).map(item => (
                    <SidebarItem key={item.key} item={item} />
                  ))}
                </div>

                <div className="jag-sidebar-divider" />

                <div className="jag-sidebar-group">
                  <div className="jag-sidebar-group-label">Global</div>
                  {(modulesAllow.global || []).map(item => (
                    <SidebarItem key={item.key} item={item} />
                  ))}
                </div>

              </div>

              <div className="jag-sidebar-bottom">
                {(modulesAllow.bottom || []).map(item => (
                  <SidebarItem key={item.key} item={item} />
                ))}
              </div>
            </div>
            )}

            {/* MAIN CONTENT */}
            <div className="jag-main">
              {/* TOPBAR */}
              <div className="jag-topbar">
                <div className="jag-topbar-left">
                  <span className="jag-topbar-module">{activeModule?.name || ''}</span>
                  <span className="jag-topbar-greeting">{msn}, {firstName}</span>
                </div>
              </div>

              {/* MODULES GRID */}
              <div className="jag-content">
                {/* T2/100A67: antes {active === "marcadores" ? (<MarkerList />) : subActive ? (...)} */}
                {subActive ? (
                  <>
                    <div className="jag-breadcrumb">
                      <span
                        className="jag-breadcrumb-back"
                        onClick={() => setSubActive(null)}
                      >
                        ← {activeModule?.name}
                      </span>
                      <span className="jag-breadcrumb-sep">/</span>
                      <span className="jag-breadcrumb-current">{subActive.title}</span>
                    </div>
                    <RenderModules
                      modules={subActive.modules}
                      name={subActive.title}
                      onSubmenu={() => {}}
                    />
                  </>
                ) : (
                  <RenderModules
                    modules={activeModules}
                    name={activeModule?.name || ''}
                    onSubmenu={(submenuKey) => {
                      const sub = SUBMENUS[submenuKey];
                      if (sub) setSubActive(sub);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </Layout>
      <Footer />
    </>
  );
}

export default Modules;
